// Thank's IE8 for his funny defineProperty
module.exports = !require('./$.fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.descriptors.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.descriptors.js
// module chunks = 0